module.exports = __webpack_public_path__ + "static/media/poligowo3.e64c5796.jpeg";